export default __webpack_public_path__ + "static/media/divide.e741ebc3.png";